import React, { useState } from 'react'
import Topnavbar from './Topnavbar'
import SideNavbar from './SideNavbar'
import Box from '@mui/material/Box';

const MainLayout = () => {

  return (
    <Box>
        <SideNavbar/>
    </Box>
  )
}

export default MainLayout
